/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Question_SectionsInputs */

const en_faq_question_sections = /** @type {(inputs: Faq_Question_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I only want to listen to the Abstract and Results.`)
};

const es_faq_question_sections = /** @type {(inputs: Faq_Question_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo quiero escuchar el Resumen y los Resultados.`)
};

/**
* | output |
* | --- |
* | "I only want to listen to the Abstract and Results." |
*
* @param {Faq_Question_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_question_sections = /** @type {((inputs?: Faq_Question_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Question_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_question_sections(inputs)
	return en_faq_question_sections(inputs)
});